import * as React from "react"

import { Button } from "../ui/button"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../ui/select"

import { FormDataProps, BusinessTypesProps } from "../CalculatorTypes"

export interface Step1Props {
    formData: FormDataProps
    options: BusinessTypesProps[]
    onNext: (type: string) => void
}

export default function Step1({ formData, options, onNext }: Step1Props) {
    const [type, setType] = React.useState(
        formData?.type || "Evento / Festival"
    )

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        if (!type) return
        onNext?.(type)
    }

    return (
        <form
            onSubmit={handleSubmit}
            className="step-shadow step1 mx-auto p-3 sm:p-6 space-y-8 flex flex-col items-center justify-center w-full rounded-3xl"
            style={{
                maxWidth: "600px",
            }}
        >
            <label
                htmlFor="business-type"
                className="text-lg sm:text-xl font-semibold poppins-font text-center mb-8 mt-4"
            >
                Siete un … ?
            </label>

            <Select value={type} onValueChange={setType}>
                <SelectTrigger
                    id="business-type"
                    className="calculator-text font-light"
                >
                    <SelectValue placeholder="Seleziona una opzione" />
                </SelectTrigger>
                <SelectContent className="">
                    {options.map(({ value, label }) => (
                        <SelectItem
                            key={value}
                            value={value}
                            className="calculator-text font-light"
                        >
                            {label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>

            <Button
                type="submit"
                disabled={!type}
                size="lg"
                className="w-full calculator-button-text font-medium"
            >
                Avanti
            </Button>
        </form>
    )
}
